import { J2Download } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { CSVLink } from 'react-csv'
import { format } from '@e3dc-react/shell/Libs/date'
import { PowerPrice } from 'src/Libs/dynamic-power-prices/types'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'
import { LabelConfig, useCsvLink } from 'src/Libs/chart-kit/shared/hooks/use-csv-link'
import { UnitTypes } from 'src/Libs/types'

type CsvData = {
  price: string
  time: string
}

const labelConfig: LabelConfig<CsvData> = {
  time: { translationKey: 'systemDataHandler.chartHeader.ts' },
  price: {
    translationKey: 'dashboard.liveView.widgets.dynamic-power-price.csv-export.price',
    unit: UnitTypes.cents,
  },
}

/*
 * A button to download the dpp widget data as a CSV file
 */
const PowerPriceChartCsvExport: React.FC<{ prices: PowerPrice[] }> = ({ prices }) => {
  const { t } = useCustomTranslation()
  const { csvHeaders, csvData } = useCsvLink<PowerPrice, CsvData>(
    prices,
    labelConfig,
    (d: PowerPrice): CsvData => ({
      /* need to use precision of 3 because Excel formats precision of 2 as a date, also need to use German formatting because "1.920" is treated as "1920" not 1,920 by Excel */
      price: getLocalizedNumber(d.price, 3, 'de'),
      time: format(new Date(d.validFrom), t('common.format.date-fns-date-time')),
    })
  )

  return (
    <Tooltip title={t('systemDataHandler.chartHeader.export')}>
      <Box component="span">
        <CSVLink
          data={csvData}
          headers={csvHeaders}
          separator={';'}
          filename={t('dashboard.liveView.widgets.dynamic-power-price.csv-export.file-name')}
        >
          <IconButton data-qa="power-price-chart-csv-button">
            <J2Download />
          </IconButton>
        </CSVLink>
      </Box>
    </Tooltip>
  )
}

export default PowerPriceChartCsvExport
